import { Gavel, Award, Headset, Shield } from "lucide-react";

export default function StatsBar() {
  const stats = [
    { icon: Gavel, value: "25+", label: "Years Experience" },
    { icon: Award, value: "5000+", label: "Cases Won" },
    { icon: Headset, value: "24/7", label: "Legal Support" },
    { icon: Shield, value: "100%", label: "Confidential" },
  ];

  return (
    <div
      className="
        relative
        bg-[linear-gradient(135deg,#111827,#1f2937,#374151)]
        border-t border-white/10
      "
    >
      {/* SUBTLE OVERLAY */}
      <div className="absolute inset-0 bg-black/25" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 py-14">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-10 text-center">
          {stats.map((item) => (
            <div
              key={item.label}
              className="flex flex-col items-center gap-3"
            >
              {/* ICON */}
              <item.icon className="w-10 h-10 md:w-12 md:h-12 text-yellow-400" />

              {/* VALUE */}
              <div className="text-3xl md:text-4xl font-bold text-yellow-400">
                {item.value}
              </div>

              {/* LABEL */}
              <div className="text-xs md:text-sm uppercase tracking-widest text-white/80">
                {item.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
